{
  "AUTOMATION": {
    "HEADER": "Automazione",
    "DESCRIPTION": "Automation can replace and streamline existing processes that require manual effort, such as adding labels and assigning conversations to the most suitable agent. This allows the team to focus on their strengths while reducing time spent on routine tasks.",
    "LEARN_MORE": "Learn more about automation",
    "HEADER_BTN_TXT": "Aggiungi regola di automazione",
    "LOADING": "Recupero delle regole di automazione",
    "ADD": {
      "TITLE": "Aggiungi regola di automazione",
      "SUBMIT": "Crea",
      "CANCEL_BUTTON_TEXT": "Annulla",
      "FORM": {
        "NAME": {
          "LABEL": "Nome regola",
          "PLACEHOLDER": "Inserisci il nome della regola",
          "ERROR": "Il nome è obbligatorio"
        },
        "DESC": {
          "LABEL": "Descrizione",
          "PLACEHOLDER": "Inserisci la descrizione della regola",
          "ERROR": "La descrizione è obbligatoria"
        },
        "EVENT": {
          "LABEL": "Evento",
          "PLACEHOLDER": "Si prega di selezionarne uno",
          "ERROR": "L'evento è obbligatorio"
        },
        "PHASE": {
          "LABEL": "Fase"
        },
        "ORDER": {
          "LABEL": "Ordine",
          "ERROR": "L'ordine è obbligatorio"
        },
        "CONDITIONS": {
          "LABEL": "Condizioni"
        },
        "ACTIONS": {
          "LABEL": "Azioni"
        }
      },
      "CONDITION_BUTTON_LABEL": "Aggiungi condizione",
      "ACTION_BUTTON_LABEL": "Aggiungi azione",
      "API": {
        "SUCCESS_MESSAGE": "Regola di automazione aggiunta con successo",
        "ERROR_MESSAGE": "Impossibile creare una regola di automazione, riprova più tardi"
      }
    },
    "LIST": {
      "404": "Nessuna regola di automazione trovata",
      "TABLE_HEADER": {
        "PHASE": "Fase",
        "ORDER": "Ordine",
        "NAME": "Nome",
        "DESCRIPTION": "Descrizione",
        "ACTIVE": "Attivo",
        "CREATED_ON": "Creato il",
        "WAIT": "Attesa"
      },
      "TABS": {
        "ALL": "Tutte",
        "INSTANT": "All'evento",
        "DELAYED": "Con ritardo"
      },
      "WAITS": "Attende {duration}"
    },
    "DELETE": {
      "TITLE": "Elimina regola di automazione",
      "SUBMIT": "Elimina",
      "CANCEL_BUTTON_TEXT": "Annulla",
      "CONFIRM": {
        "TITLE": "Conferma eliminazione",
        "MESSAGE": "Sei sicuro di voler eliminare ",
        "YES": "Sì, elimina ",
        "NO": "No, conserva "
      },
      "API": {
        "SUCCESS_MESSAGE": "Regola di automazione eliminata con successo",
        "ERROR_MESSAGE": "Impossibile eliminare una regola di automazione, riprova più tardi"
      }
    },
    "EDIT": {
      "TITLE": "Modifica regola di automazione",
      "SUBMIT": "Aggiorna",
      "CANCEL_BUTTON_TEXT": "Annulla",
      "API": {
        "SUCCESS_MESSAGE": "Regola di automazione aggiornata con successo",
        "ERROR_MESSAGE": "Impossibile aggiornare la regola di automazione, riprova più tardi"
      }
    },
    "CLONE": {
      "TOOLTIP": "Clona",
      "API": {
        "SUCCESS_MESSAGE": "Automazione clonata con successo",
        "ERROR_MESSAGE": "Impossibile clonare la regola di automazione, riprova più tardi"
      }
    },
    "FORM": {
      "EDIT": "Modifica",
      "CREATE": "Crea",
      "DELETE": "Elimina",
      "CANCEL": "Annulla",
      "RESET_MESSAGE": "Cambiare il tipo di evento resetterà le condizioni e gli eventi che hai aggiunto di seguito"
    },
    "CONDITION": {
      "DELETE_MESSAGE": "È necessario avere almeno una condizione per salvare",
      "CONTACT_CUSTOM_ATTR_LABEL": "Contact Custom Attributes",
      "CONVERSATION_CUSTOM_ATTR_LABEL": "Conversation Custom Attributes"
    },
    "ACTION": {
      "DELETE_MESSAGE": "È necessario avere almeno una azione da salvare",
      "TEAM_MESSAGE_INPUT_PLACEHOLDER": "Inserisci qui il tuo messaggio",
      "TEAM_DROPDOWN_PLACEHOLDER": "Seleziona i team",
      "EMAIL_INPUT_PLACEHOLDER": "Enter email",
      "URL_INPUT_PLACEHOLDER": "Enter URL",
      "SENDER_DROPDOWN_PLACEHOLDER": "Seleziona la casella email e l'indirizzo mittente",
      "SUBJECT_INPUT_PLACEHOLDER": "Oggetto dell'email",
      "SMS_INBOX_DROPDOWN_PLACEHOLDER": "Seleziona la casella SMS da cui inviare",
      "SMS_MESSAGE_INPUT_PLACEHOLDER": "Inserisci il testo dell'SMS",
      "SMS_COUNTER": "{length}/{limit} caratteri, {segments} SMS (prima della compilazione delle variabili)"
    },
    "TOGGLE": {
      "ACTIVATION_TITLE": "Attiva regola di automazione",
      "DEACTIVATION_TITLE": "Disattiva regola di automazione",
      "ACTIVATION_DESCRIPTION": "Questa azione attiverà la regola di automazione '{automationName}'. Sei sicuro di voler procedere?",
      "DEACTIVATION_DESCRIPTION": "Questa azione disattiverà la regola di automazione '{automationName}'. Sei sicuro di voler procedere?",
      "ACTIVATION_SUCCESFUL": "Regola di automazione attivata con successo",
      "DEACTIVATION_SUCCESFUL": "Regola di automazione disattivata con successo",
      "ACTIVATION_ERROR": "Impossibile attivare l'automazione, riprova più tardi",
      "DEACTIVATION_ERROR": "Impossibile disattivare l'automazione, riprova più tardi",
      "CONFIRMATION_LABEL": "Sì",
      "CANCEL_LABEL": "No"
    },
    "ATTACHMENT": {
      "UPLOAD_ERROR": "Impossibile caricare l'allegato, si prega di riprovare",
      "LABEL_IDLE": "Carica allegato",
      "LABEL_UPLOADING": "Caricamento...",
      "LABEL_UPLOADED": "Successfully Uploaded",
      "LABEL_UPLOAD_FAILED": "Caricamento fallito"
    },
    "ERRORS": {
      "ATTRIBUTE_KEY_REQUIRED": "Attribute key is required",
      "FILTER_OPERATOR_REQUIRED": "Filter operator is required",
      "VALUE_REQUIRED": "Il valore è obbligatorio",
      "VALUE_MUST_BE_BETWEEN_0_AND_998": "Il valore deve essere compreso tra 0 e 998",
      "ACTION_PARAMETERS_REQUIRED": "Action parameters are required",
      "ATLEAST_ONE_CONDITION_REQUIRED": "At least one condition is required",
      "ATLEAST_ONE_ACTION_REQUIRED": "At least one action is required",
      "ORDER_REQUIRED": "L'ordine è obbligatorio",
      "ORDER_MUST_BE_AT_LEAST_ONE": "L'ordine deve essere almeno 1"
    },
    "ACTION_NOTICES": {
      "SKIP_AUTO_PRIORITY": "Questa azione funziona solo quando la fase della regola è impostata su 'Prima dell'etichettatura'.",
      "SKIP_AUTO_LABELING": "Questa azione funziona solo quando la fase della regola è impostata su 'Prima dell'etichettatura'.",
      "MOVE_CONVERSATION_TO_INBOX": "Solo le conversazioni email e della chat web possono essere spostate in una casella email, una chat web solo se il contatto ha un indirizzo email. Altrimenti la conversazione non viene spostata e viene invece aggiunta una nota privata.",
      "SEND_MESSAGE_IN_NEW_CONVERSATION": "Avvia una nuova conversazione con il contatto nella casella email selezionata, gli invia il messaggio via email e risolve la conversazione. Succede ogni volta che la regola viene eseguita. Se il contatto non ha un indirizzo email, non viene inviato nulla e viene aggiunta invece una nota privata.",
      "SEND_SMS_IN_NEW_CONVERSATION": "Avvia una nuova conversazione con il contatto nella casella SMS selezionata, gli invia il messaggio via SMS e risolve la conversazione. Succede ogni volta che la regola viene eseguita. Il messaggio è testo semplice senza allegati. Se il contatto non ha un numero di telefono, non viene inviato nulla e viene aggiunta invece una nota privata."
    },
    "NOTICES": {
      "AI_PROMPT": "Ogni singola valutazione viene addebitata.",
      "INCOMING_MESSAGES_COUNT": "Si riferisce al numero di messaggi in entrata nella conversazione.",
      "OUTGOING_MESSAGES_COUNT": "Si riferisce al numero di messaggi in uscita nella conversazione."
    },
    "PHASE": {
      "BEFORE_LABELING": "Prima dell'etichettatura",
      "AFTER_LABELING": "Dopo l'etichettatura"
    },
    "NONE_OPTION": "Nessuno",
    "MESSAGE_TYPE_VALUES": {
      "INCOMING": "Messaggio in entrata",
      "OUTGOING": "Messaggio in uscita",
      "PRIVATE": "Nota privata",
      "AI_SUMMARY": "Riassunto AI"
    },
    "YES_NO_VALUES": {
      "YES": "Sì",
      "NO": "No"
    },
    "MESSAGE_SOURCE_TYPE_VALUES": {
      "FACEBOOK_MESSENGER": "Facebook Messenger",
      "INSTAGRAM_DM": "Messaggio diretto Instagram",
      "FACEBOOK_COMMENT": "Commento Facebook"
    },
    "EVENTS": {
      "CONVERSATION_CREATED": "Conversazione creata",
      "CONVERSATION_UPDATED": "Conversazione aggiornata",
      "MESSAGE_CREATED": "Messaggio creato",
      "CONVERSATION_OPENED": "Conversazione aperta",
      "CONVERSATION_RESOLVED": "Conversazione risolta",
      "PHONE_CALL_FINISHED": "Chiamata terminata"
    },
    "ACTIONS": {
      "ASSIGN_AGENT": "Assegna a un agente",
      "ASSIGN_TEAM": "Assegna a un team",
      "ADD_LABEL": "Aggiungi un'etichetta",
      "REMOVE_LABEL": "Rimuovi un'etichetta",
      "SEND_EMAIL_TO_TEAM": "Invia un'email al team",
      "SEND_EMAIL_TRANSCRIPT": "Invia una trascrizione via email",
      "SEND_EMAIL_TRANSCRIPT_WITH_DETAILS": "Invia una trascrizione dettagliata via email",
      "MUTE_CONVERSATION": "Silenzia conversazione",
      "SNOOZE_CONVERSATION": "Posticipa conversazione",
      "RESOLVE_CONVERSATION": "Risolvi conversazione",
      "OPEN_CONVERSATION": "Apri conversazione",
      "SEND_WEBHOOK_EVENT": "Invia evento webhook",
      "SEND_ATTACHMENT": "Invia allegato",
      "SEND_MESSAGE": "Invia un messaggio",
      "ADD_NOTE": "Aggiungi una nota",
      "CHANGE_PRIORITY": "Cambia priorità",
      "ADD_SLA": "Aggiungi SLA",
      "SKIP_AUTO_PRIORITY": "Salta priorità automatica",
      "SKIP_AUTO_LABELING": "Salta etichettatura automatica",
      "AUTO_TRANSLATE": "Traduci messaggio",
      "AUTO_TRANSLATE_CONVERSATION": "Traduci conversazione",
      "MOVE_CONVERSATION_TO_INBOX": "Sposta conversazione in una casella",
      "SEND_MESSAGE_IN_NEW_CONVERSATION": "Invia un messaggio in una nuova conversazione",
      "SEND_SMS_IN_NEW_CONVERSATION": "Invia un SMS in una nuova conversazione",
      "STOP_PROCESSING_RULES": "Interrompi elaborazione regole"
    },
    "ATTRIBUTES": {
      "EXTENSION": "Interno chiamato",
      "WORKING_HOURS": "Entro l'orario di lavoro",
      "AGENT_REPLIED": "Un agente ha risposto dopo il cambio di stato",
      "AI_FILTER": "Filtro AI",
      "MESSAGE_TYPE": "Tipo di messaggio",
      "MESSAGE_CONTAINS": "Contenuto del messaggio",
      "EMAIL": "Email",
      "INBOX": "Casella",
      "CHANNEL_TYPE": "Tipo di casella",
      "CONVERSATION_LANGUAGE": "Lingua della conversazione",
      "PHONE_NUMBER": "Numero di telefono",
      "STATUS": "Stato",
      "BROWSER_LANGUAGE": "Lingua del browser",
      "MAIL_SUBJECT": "Oggetto email",
      "COUNTRY_NAME": "Paese",
      "MARKETPLACE_COUNTRY": "Paese del marketplace",
      "REFERER_LINK": "Link di riferimento",
      "ASSIGNEE_NAME": "Assegnatario",
      "TEAM_NAME": "Team",
      "PRIORITY": "Priorità",
      "CALL_DIRECTION": "Direzione della chiamata",
      "MISSED_CALL": "Chiamata persa",
      "MISSED_CALL_COUNT": "Numero di chiamate perse",
      "MESSAGE_SOURCE_TYPE": "Tipo di origine del messaggio",
      "INCOMING_MESSAGE_COUNT": "Numero di messaggi in entrata",
      "OUTGOING_MESSAGE_COUNT": "Numero di messaggi in uscita",
      "LABEL": "Etichetta",
      "EMAIL_RECIPIENTS": "Destinatario email",
      "EMAIL_AUTO_REPLY": "L'email è una risposta automatica",
      "ATTACHMENT_EXTENSION": "Estensione allegato"
    },
    "WAIT": {
      "RUN_LABEL": "Esegui le azioni",
      "INSTANT": "All'evento",
      "DELAYED": "Con ritardo",
      "TRIGGER_LABEL": "Attendi finché",
      "TRIGGERS": {
        "CONVERSATION_STATUS": "Una conversazione resta in uno stato",
        "CUSTOMER_UNRESPONSIVE": "Il cliente non risponde a un agente",
        "AGENT_UNRESPONSIVE": "Il cliente non riceve risposta da un agente"
      },
      "STATUS_LABEL": "Stato",
      "STATUSES": {
        "OPEN": "Aperta",
        "PENDING": "In attesa",
        "SNOOZED": "Posticipata",
        "RESOLVED": "Risolta"
      },
      "DELAY_LABEL": "Attesa",
      "DELAY_ERROR": "Inserisci un'attesa tra 1 minuto e 30 giorni",
      "DURATION": {
        "MINUTES": "{count} min",
        "HOURS": "{count} h",
        "DAYS": "{count} g"
      },
      "EXPLANATION": {
        "CONVERSATION_STATUS": "Le azioni vengono eseguite quando una conversazione è nello stato {status} da {duration}. Un cambio di stato prima le annulla. Etichette, orario di lavoro e risposte degli agenti vengono verificati al termine dell'attesa.",
        "CUSTOMER_UNRESPONSIVE": "Le azioni vengono eseguite quando il cliente non risponde da {duration} al messaggio di un agente. Una risposta del cliente le annulla; un nuovo messaggio dell'agente fa ripartire l'attesa.",
        "AGENT_UNRESPONSIVE": "Le azioni vengono eseguite quando il cliente attende da {duration} senza risposta di un agente. Una risposta dell'agente le annulla."
      }
    }
  }
}
